import { Phone, MapPin } from "lucide-react";
import { useT } from "@/lib/i18n";
import { PHONE, PHONE_E164 } from "@/lib/data";

export const Footer = ({ lang }) => {
  const t = useT(lang);
  const year = new Date().getFullYear();

  return (
    <footer
      data-testid="site-footer"
      className="bg-[#3d2a1b] text-[#f0e3c7] py-12 border-t border-[#8a6a3f]/30"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 grid sm:grid-cols-3 gap-8 items-start">
        <div>
          <div className="font-serif-display text-2xl text-[#f7f1e6]">
            Skyline Retreat
          </div>
          <p className="text-xs text-[#c9b58d] mt-2 max-w-xs">
            {t.footer.tagline}
          </p>
        </div>

        <div className="text-sm space-y-2">
          <div className="text-[11px] uppercase tracking-widest text-[#e8c875]">
            {t.footer.contact}
          </div>
          <a
            href={`tel:${PHONE_E164}`}
            className="flex items-center gap-2 hover:text-[#f7f1e6]"
          >
            <Phone className="w-3.5 h-3.5" /> {PHONE}
          </a>
          <div className="flex items-center gap-2">
            <MapPin className="w-3.5 h-3.5" /> {t.location.address}
          </div>
        </div>

        <div className="text-xs text-[#c9b58d] sm:text-right flex flex-col sm:items-end gap-3">
          <span>© {year} Skyline Retreat. {t.footer.rights}</span>
          <div id="emergent-badge-slot" data-testid="emergent-badge-slot" className="inline-flex" />
        </div>
      </div>
    </footer>
  );
};
